import produce from 'immer';

import {
  CARD_LOADING,
  ORDER_LOADING,
  USERS_LOADING,
  OAUTH_LOADING,
  STRATAS_LOADING,
  STRATA_LOADING,
  ORDERS_LOADING,
  COUNCIL_LOADING,
  ADDRESS_LOADING,
  SESSION_LOADING,
  COUNCILS_LOADING,
  CONNECT_LOADING,
  INVITATION_LOADING,
  SESSION_GET_LOADING,
  ORDER_UPLOAD_LOADING,
  ADDRESS_PAGE_LOADING,
  ORDER_UPDATE_LOADING,
  SESSION_RESET_LOADING,
  ADDRESS_SEARCH_LOADING,
  INVITATIONS_LOADING,
  CHECKOUT_LOADING,
  INVITE_RESPONSE_LOADING,
  USERS_INVITE_LOADING,
  SESSION_DETAILS_LOADING
} from 'constants/actions';

export var INITIAL_STATE = {
  loadingCard: false,
  loadingOrder: false,
  loadingUsers: false,
  loadingOrders: false,
  loadingStrata: false,
  loadingStratas: false,
  loadingCouncil: false,
  loadingInvites: false,
  loadingDetails: false,
  loadingInvite: false,
  loadingSession: false,
  loadingCouncils: false,
  loadingConnect: false,
  loadingAddresses: false,
  loadingOauthClient: false,
  loadingCheckout: false,
  loadingOrderUpdate: false,
  loadingResetPassword: false,
  loadingSearchAddress: false,
  loadingAddressPage: false,
  loadingSessionUpdate: false,
  loadingInviteUser: false,
  loadingInviteResponse: false,
  loadingUpload: false
};

export const loading = produce((draft, action) => {
  switch (action.type) {
    case COUNCILS_LOADING:
      draft.loadingCouncils = action.value;
      return draft;

    case CHECKOUT_LOADING:
      draft.loadingCheckout = action.value;
      return draft;

    case OAUTH_LOADING:
      draft.loadingOauthClient = action.value;
      return draft;

    case COUNCIL_LOADING:
      draft.loadingCouncil = action.value;
      return draft;

    case ORDER_UPLOAD_LOADING:
      draft.loadingUpload = action.value;
      return draft;

    case ORDER_LOADING:
      draft.loadingOrder = action.value;
      return draft;

    case ORDER_UPDATE_LOADING:
      draft.loadingOrderUpdate = action.value;
      return draft;

    case ORDERS_LOADING:
      draft.loadingOrders = action.value;
      return draft;

    case ADDRESS_LOADING:
      draft.loadingAddresses = action.value;
      return draft;

    case ADDRESS_SEARCH_LOADING:
      draft.loadingSearchAddress = action.value;
      return draft;

    case CARD_LOADING:
      draft.loadingCard = action.value;
      return draft;

    case SESSION_LOADING:
      draft.loadingSession = action.value;
      return draft;

    case SESSION_DETAILS_LOADING:
      draft.loadingDetails = action.value;
      return draft;

    case SESSION_RESET_LOADING:
      draft.loadingResetPassword = action.value;
      return draft;

    case ADDRESS_PAGE_LOADING:
      draft.loadingAddressPage = action.value;
      return draft;

    case SESSION_GET_LOADING:
      draft.loadingSessionUpdate = action.value;
      return draft;

    case USERS_LOADING:
      draft.loadingUsers = action.value;
      return draft;

    case INVITATIONS_LOADING:
      draft.loadingInvites = action.value;
      return draft;

    case INVITATION_LOADING:
      draft.loadingInvite = action.value;
      return draft;

    case INVITE_RESPONSE_LOADING:
      draft.loadingInviteResponse = action.value;
      return draft;

    case USERS_INVITE_LOADING:
      draft.loadingInviteUser = action.value;
      return draft;

    case CONNECT_LOADING:
      draft.loadingConnect = action.value;
      return draft;

    case STRATAS_LOADING:
      draft.loadingStratas = action.value;
      return draft;

    case STRATA_LOADING:
      draft.loadingStrata = action.value;
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default loading;
